"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLeadsNotifications = exports.markNotificationAsRead = exports.getUnreadLeadsNotifications = exports.getLeadsNotificationsById = exports.getLeadsNotifications = exports.deleteLeadsNotifications = exports.defaultLeadsNotificationsData = exports.createLeadsNotifications = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultLeadsNotificationsData = exports.defaultLeadsNotificationsData = {
  id: 0,
  enabled: true,
  title: '',
  message: '',
  page: '',
  adminId: undefined,
  admin: undefined,
  isRead: false
};
const getLeadsNotifications = params => (0, _request.default)({
  url: '/leads-notifications',
  method: 'get',
  params
});
exports.getLeadsNotifications = getLeadsNotifications;
const getLeadsNotificationsById = id => (0, _request.default)({
  url: `/leads-notifications/${id}`,
  method: 'get'
});
exports.getLeadsNotificationsById = getLeadsNotificationsById;
const updateLeadsNotifications = (id, data) => (0, _request.default)({
  url: `/leads-notifications/${id}`,
  method: 'patch',
  data
});
exports.updateLeadsNotifications = updateLeadsNotifications;
const deleteLeadsNotifications = id => (0, _request.default)({
  url: `/leads-notifications/${id}`,
  method: 'delete'
});
exports.deleteLeadsNotifications = deleteLeadsNotifications;
const createLeadsNotifications = data => (0, _request.default)({
  url: '/leads-notifications/',
  method: 'post',
  data
});
exports.createLeadsNotifications = createLeadsNotifications;
const getUnreadLeadsNotifications = params => (0, _request.default)({
  url: '/leads-notifications/unread',
  method: 'get',
  params
});
exports.getUnreadLeadsNotifications = getUnreadLeadsNotifications;
const markNotificationAsRead = id => (0, _request.default)({
  url: '/leads-notifications/mark-as-read',
  method: 'post',
  data: {
    id
  }
});
exports.markNotificationAsRead = markNotificationAsRead;